<template>
  <div id="mainContent" class="scene-detail content">
    <!-- 弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowPop" width="90%" @close="closeTrend">
      <el-form ref="bindDeviceModel" label-position="right">
        <el-form-item>
          <!-- 日期选择器 -->
          <el-date-picker
            v-model="popStartDate"
            type="datetime"
            size="mini"
            value-format="timestamp"
            :placeholder="$t('AllDevices.startDate')"
            :clearable="false"
          />
          <span>{{ $t('AllDevices.to') }}</span>
          <el-date-picker
            v-model="popEndDate"
            type="datetime"
            size="mini"
            value-format="timestamp"
            :placeholder="$t('AllDevices.endDate')"
            :clearable="false"
          />
          <el-button class="filter-item" type="primary" size="mini" icon="el-icon-search" @click="changeSearch" />
          <el-button size="mini" type="primary" align="right" style="text-align: center;float:right;margin-right: 40px" @click="downLoadExcel()">Download Raw CSV</el-button>
          <el-button size="mini" type="primary" align="right" style="text-align: center;float:right;margin-right: 40px" @click="downLoadReportExcel()">Download Report CSV</el-button>

        </el-form-item>
      </el-form>
      <el-form ref="bindDeviceModel" v-loading="loading" label-position="right">
        <el-form-item style="position:relative;">
          <p v-if="nodata" style="text-align: center;line-height: 30px;top: 50%;position: absolute;width: 100%;transform: translate(0, -50%);z-index:99;">{{ $t("yhubReport.Nodata") }}</p>
          <line-chart :line-chart-data="lineChartData" :height="lineHeight" :is-show-half-v="isShowHalfV" @legendselect="legendselect" />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 用逗号" , "作小数点分隔符 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowRegionPop" class="regionPop" width="60%" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
      <p class="regionP">{{ $t('yhubReport.UseComma') }} </p>
      <el-radio v-model="regionType" :label="2" @change="change">{{ $t('allDeviceDetail.Yes') }}</el-radio>
      <el-radio v-model="regionType" :label="1" @change="change">{{ $t('allDeviceDetail.no') }}</el-radio>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowRegionPop = false">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" @click="submitPop">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>
    <!-- 下载中 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowLoadingPop" width="60%" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
      <p>{{ $t('button.Downloading') }}</p>
    </el-dialog>
  </div>
</template>
<script>
import { listRecordData } from '@/api/yhub'
import { getDateAndHour } from '@/utils/updateTime.js'
import lineChart from '@/components/lineChart'
import i18n from '@/i18n'
import { parseTime } from '@/utils'
// MQTT--------------start
import mqtt from 'mqtt'
import yhubproto from '@/proto/yhubproto'
import protobuf from 'protobufjs'
import { MQTT_SERVICE, MQTT_USERNAME, MQTT_PASSWORD } from '@/utils/sysconstant.js'
import { temChange, temChangeUnit, temUnit } from '@/utils/temChange.js'
// const YhubRequest = yhubproto.lookup('framework.YhubRequest')
var myOoptions = {}
client = mqtt.connect(MQTT_SERVICE, myOoptions)
var client
// MQTT--------------end
import apiproto from '@/proto/apiproto'
const GNSSProto = apiproto.lookup('com.yhub.pb.APIResponse')

export default {
  components: {
    lineChart
  },
  props: {
    showYhubTrendPop: {
      type: Boolean,
      default: true
    },
    basicinfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    this.apiproto
    this.protobuf
    return {
      isShowPop: this.showYhubTrendPop,
      lineChartData: {
        d3: [],
        d4: [],
        d5: [],
        d6: [],
        d7: [],
        d8: [],
        d9: [],
        d10: [],
        d11: [],
        a1: [],
        a2: [],
        a3: [],
        a32: [],
        a4: [],
        a5: [],
        a6: [],
        a7: []
      },
      lineHeight: '600px',
      isShowHalfV: 0,
      legendselectStr: [],
      popStartDate: new Date().getTime() - 1 * 24 * 60 * 60 * 1000,
      popEndDate: new Date().getTime(),
      nodata: false,
      loading: false,
      isShowLoadingPop: false,
      isShowRegionPop: false,
      regionType: 2,
      showAll: false
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    showYhubTrendPop(val) {
      this.isShowPop = val
      if (this.isShowPop) this.changeSearch()
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  mounted() {

  },
  methods: {
    closeTrend() {
      this.popStartDate = new Date().getTime() - 1 * 24 * 60 * 60 * 1000
      this.popEndDate = new Date().getTime()
      this.$emit('closeTrendPop')
    },
    queryLine() { // 弹窗--折线图
      var params = {
        // sn: this.popSn,
        startDate: this.popStartDate,
        endDate: this.popEndDate,
        mcuId: this.basicinfo.mcuId,
        showAll: true
      }
      listRecordData(params).then(res => { // 弹窗折线图数据
        this.loading = false
        var gnssProto
        const buf = protobuf.util.newBuffer(res)
        gnssProto = GNSSProto.decode(buf)
        const dataList = gnssProto.recordDatas ? gnssProto.recordDatas.recordData : []
        this.nodata = !(dataList.length > 0)
        for (const i in this.lineChartData) {
          this.lineChartData[i] = []
        }
        console.log('dataList----', dataList)
        // ['Cha.(A)', 'Dis.(A)', 'Volt(V)', 'Cha.(Ah)', 'Dis.(Ah)', 'SOC(%)', 'Temp.(℃)']
        var lastTime = null
        var dataSize = dataList.length
        for (const i in dataList) {
          var data = dataList[i]
          var time = dataList[i].time
          if (dataSize > 50000) {
            if (lastTime == null) {
              lastTime = time
            }
            if ((time - lastTime) / 1000 <= 10) {
              continue
            }
            lastTime = time
          }
          var ignition = data.ignitionVol / 100 > this.basicinfo.openIgnitionVol ? 1 : 0
          var hourMeter = data.hourMeterVol / 100 > this.basicinfo.workHourmeterVol ? 1 : 0
          this.lineChartData.sn = this.basicinfo.deviceSn
          this.lineChartData.d3.push([time, (data.ChargingCurrent / 100).toFixed(2)])
          this.lineChartData.d4.push([time, (data.DisChargingCurrent / 100).toFixed(2)])
          this.lineChartData.d5.push([time, (data.voltage / 100).toFixed(2)])
          this.lineChartData.d6.push([time, (data.TotalChargedAh / 100).toFixed(2)])
          this.lineChartData.d7.push([time, (data.TotalDisChargedAh / 100).toFixed(2)])
          this.lineChartData.d8.push([time, (data.soc / 100).toFixed(0)])
          this.lineChartData.d9.push([time, temChange((data.BatteryTemperature / 100).toFixed(0))])
          this.lineChartData.d10.push([time, (data.chargingWh / 100000).toFixed(2)])
          this.lineChartData.d11.push([time, (data.usingWh / 100000).toFixed(2)])
          this.lineChartData.a1.push([time, ignition])
          this.lineChartData.a2.push([time, hourMeter])
          this.lineChartData.a3.push([time, (data.auxBatVol / 100).toFixed(2)])
          this.lineChartData.a32.push([time, (data.voltage / 100 - data.auxBatVol / 100).toFixed(2)])
          if (data.auxCurrent > 0) { // 放电
            this.lineChartData.a4.push([time, (data.auxCurrent / 10).toFixed(2)])
            this.lineChartData.a5.push([time, 0])
          } else if (data.auxCurrent < 0) { // 充电
            this.lineChartData.a4.push([time, 0])
            this.lineChartData.a5.push([time, -(data.auxCurrent / 10).toFixed(2)])
          } else {
            this.lineChartData.a4.push([time, 0])
            this.lineChartData.a5.push([time, 0])
          }
          this.lineChartData.a6.push([time, (data.auxSoc / 100).toFixed(0)])
          this.lineChartData.a7.push([time, (data.socVolt / 100).toFixed(0)])
        }
      })// 当在监控点击切换的时候，加个延迟主动触发窗口变化，这样窗口改变性能分析页就不会发生图表大小有问题的情况了 【这里的代码是关键！！！】
      setTimeout(() => {
        const triggerResize = new Event('resize')
        window.dispatchEvent(triggerResize)
      }, 0)
    },
    changeSearch() { // 弹窗--时间选择
      this.loading = true
      this.queryLine()
    },
    change() {
      this.$forceUpdate()
    },
    submitPop() { // Download Raw CSV--下载
      this.isShowRegionPop = false
      this.isShowLoadingPop = true
      setTimeout(() => {
        this.isShowLoadingPop = false
      }, 5000)
      var param = {
        sn: this.basicinfo.deviceSn,
        mcuId: this.basicinfo.mcuId,
        startDate: this.popStartDate,
        endDate: this.popEndDate
      }
      var timeZ = new Date().getTimezoneOffset() / 60

      var paramTimeZ = 'GMT'
      if (timeZ < 0) {
        paramTimeZ = paramTimeZ + '%2B' + (timeZ * -1)
      } else {
        paramTimeZ = paramTimeZ + (timeZ * -1)
      }
      // console.log(param)
      // var url = 'http://10.0.0.22:8008/v3/report/exportRecordDataCsv'
      var url = process.env.VUE_APP_BASE_API + '/v3/report/exportRecordDataCsv'
      url += '?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate + '&sn=' + param.sn + '&columns=' + this.legendselectStr + '&timeZone=' + paramTimeZ + '&regionType=' + this.regionType + '&showAll=true'
      window.open(url, '_bank')
    },
    downLoadExcel() { // Download Raw CSV--打开选中数字分割选项的弹窗
      this.isShowRegionPop = true
    },
    downLoadReportExcel() { // Download Report CSV
      this.isShowLoadingPop = true
      setTimeout(() => {
        this.isShowLoadingPop = false
      }, 5000)
      var param = {
        sn: this.basicinfo.deviceSn,
        mcuId: this.basicinfo.mcuId,
        startDate: parseInt(new Date(this.popStartDate).getTime()),
        endDate: parseInt(new Date(this.popEndDate).getTime())
      }
      var timeZ = new Date().getTimezoneOffset() / 60
      var paramTimeZ = 'GMT'
      if (timeZ < 0) {
        paramTimeZ = paramTimeZ + '%2B' + (timeZ * -1)
      } else {
        paramTimeZ = paramTimeZ + (timeZ * -1)
      }
      var tem = this.$store.state.temType == 'hsd' ? 'F' : 'C'
      // var url = 'http://10.0.0.22:8008/v3/report/exportRecordDataCsv'
      var url = process.env.VUE_APP_BASE_API + '/v3/report/getcsv?sn='
      // url += '?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate + '&sn=' + this.listQuery.sn
      url += param.sn + '&startTime=' + param.startDate + '&endTime=' + param.endDate + '&timeZone=' + paramTimeZ + '&showAll=true' + '&tem=' + tem
      window.open(url, '_bank')
    },
    legendselect(str) {
      this.legendselectStr = str
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    }

  }
}
function timestampformat(timestamp) {
  // return (new Date(timestamp)).Format('dd/MM hh:mm')
  return getDateAndHour(new Date(timestamp), 'noYear')
}
</script>

<style lang="scss" scoped>
// @import './resettable.css';
@media print {
  html,body {
      //A4默认为210mm*287mm
      width:210mm;
      height:297mm;
  }
  .page{
      font-size:10pt;
      width:initial;
  }
  .page .part2 td{
      height:1cm;
  }
  // .myTable{
  //   width:200mm;
  // }
}
*{
  // padding:0;
  margin:0;
  font-family: '微软雅黑';
}
.regionP{
  margin: 10px;
  font-weight: bold;
  display: inline-block;
}
.regionPop .el-radio{
  margin-left:10px;
}
// .columnTable tr:nth-of-type(even){
.oddTr{
  background:#f0f2f5a3;
}
.questionPop,.dischargePop,.WorkTimeWarp,.usedTimeWarp{
  display: inline-block;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  // margin: -120px 0 0 160px;
  left: 120px;
  bottom: 40px;
  max-width: 100%;
}
.questionPop{
  width:100%;
}
.dischargePop{
  margin: 0;
  width: auto;
  bottom: auto;
  left: 50%;
  top: 25px;
  transform: translate(-50%, 0);
}
.WorkTimeWarp,.usedTimeWarp{
  margin: 0;
  left: 10%;
  width: auto;
  bottom: auto;
  top: -50px;
}
.usedTimeWarp{
  left: 15%;
}
.yhubHeader{
  background: white;
  height: 108px;
  margin:0!important;
  // margin-right:0!important;
}
.yhubHeaderP{
  display: inline-block;
  width: 100%;
  line-height: 108px;
  font-size: 20px;
  font-weight: bold;
  position: relative;
  padding-left:20px
}
.yhubHeaderP span{
  font-size: 16px;
  line-height: 16px;
  font-weight: normal;
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.blockTitleP{
  font-size: 16px;
  color: #000;
  line-height: 16px;
  font-weight: bold;
  padding: 20px 0;
}
.warningP{
  background: #ffffcc;
  line-height: 40px;
  border: 1px solid #ffcc99;
  border-radius: 5px;
  padding-left: 10px;
  margin:5px 0;
}
.changePieBtn{
  outline: none;    //消除默认点击蓝色边框效果
  height: 25px;
  padding: 0 10px;
  font-size: 14px;
  border-radius: 4px;
  border:1px solid #c2e7b0;
  background:#f0f9eb;
  margin-bottom: 10px;
  position: relative;
}
.changePieBtn:nth-of-type(1){
  // margin-right:10px;
  margin-left: calc(1% + 5px);
}
.active{
  border:1px solid #67c23a;
  background:#67c23a;
  color:white;
}
.downBtn{
  height: 35px;
  line-height: 35px;
  background: #a9d252;
  display: inline-block;
  border-radius: 10px;
  padding: 0 10px;
  color: white;
  position: absolute;
  right: 30px;
  top: 20px;
  cursor: pointer;
}
.popWrap{
  background:  rgba(0,0,0,0.5);
  position: fixed;
  z-index: 2;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popContent{
  background: white;
  width: 80%;
  height: 80%;
  padding:20px;
}
#mainContent .el-dialog {
  margin-top: 10vh!important;
}
</style>
<style lang="scss">
#mainContent{
  .myTable .el-table__body tr:hover>td{
    background-color: #fff!important;
  }
  .searchWarp{
    display: flex;
    align-items: center;
  }
  .selectTab{
    display: inline-block;
    margin-left:20px;
    .el-tabs__header{
      display: inline-block!important;
      margin-bottom: 0;
    }
    .el-tabs__nav{
      background: #dfe4ed6b;
      border-top:none;
    }
    .el-tabs__item{
      border-top: 1px solid #dfe4ed;
      height: 36px;
      line-height: 34px;
    }
    .el-tabs__item.is-active{
      background: #1990fc;
      border-bottom: 1px solid #1990fc;
      border-top: 1px solid #1990fc;
      color:#fff;
    }
    .el-tabs__item:nth-of-type(1).is-active{
      border-radius: 3px 0 0 0;
    }
    .el-tabs__item:nth-of-type(3).is-active{
      border-radius:0 3px 0 0;
    }
  }
  .columnLineWarp{
    .el-icon-question{
      top: 3px;
      position: absolute;
      left: calc(50% + 60px);
    }
    .en,.de{
      left: calc(50% + 60px);
    }
    .kl,.zh,.ft{
      left: calc(50% + 30px);
    }
    .ja{
      left: calc(50% + 50px);
    }
  }
}
.SummaryWarp{
  .el-icon-question{
    margin-left:5px;
  }
}
.chargedRecordTable{
  tr th:nth-last-child(1),tr td:nth-last-child(1){
    border-left: 1px solid #dfe6ec;
  }
  tbody tr:nth-of-type(1) td:nth-last-child(1){
    border-top: 1px solid #dfe6ec;
  }
}
</style>
